module.exports = require("fast-safe-stringify");